import React, { useContext, useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import states from "../../data/states";
import { useNavigate, useLocation } from "react-router-dom";
import leloContext from "../../context/leloreg/leloContext";
import { toast } from "react-toastify";

const R5MailingAddress = () => {
  const {
    formData,
    onFormDataChange,
    pass: { mailing },
  } = useContext(leloContext);

  const [FormSubmit, setFormSubmit] = useState(false);

  const { mailingStreet, mailingCity, mailingState, mailingZip, charter, charter_id } = formData;

  const navigate = useNavigate();
  const location = useLocation();
  const { _uuid, pgRelationshipToStudent, LeloRegistrationProfile, _id, permalink } = location.state || {};

  //Return to Start if formData.Charter is missing
  
  // useEffect(() => {
  //   if (!charter_id) {
  //     alert("Something went wrong");
       
  //     if (_uuid === undefined) {
  //       history.push(`/forms/${permalink}/${_id}`);
  //     } else {
  //       history.push(`/forms/${permalink}/${_uuid}/${LeloRegistrationProfile}`);
  //     }
  //   }
  // }, [charter_id, history, permalink, LeloRegistrationProfile, _id, _uuid]);
   
  useEffect(() => {
    if (!charter_id) {
      toast.error("Something went wrong");

      if (_uuid === undefined) {
        navigate(`/forms/${permalink}`);
      } else {
        navigate(`/forms/${permalink}/${_uuid}`);
      }
    }
  }, [charter_id, navigate, permalink, LeloRegistrationProfile, _id, _uuid]);
   
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mailingStreet" || name === "mailingCity") {
      onFormDataChange({
        target: {
          name,
          value: value
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" "),
        },
      });
    } else {
      onFormDataChange(e);
    }
  };

  const handleZipChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 5) {
      onFormDataChange({
        target: {
          name: "zip",
          value: value,
        },
      });
    }
  };

  const validatezipCode = (zip) => {
    const re = /^[0-9]{5}$/; 
    return re.test(zip);
  };

  const MailingFilledOut =
    mailingStreet &&
    mailingCity &&
    mailingState &&
    mailingZip &&
    validatezipCode(mailingZip);

  const handleSubmit = () => {
    setFormSubmit(true); // Mark the form as submit
    if (MailingFilledOut) {
      navigate("/leloStudent4", { state: { permalink, _uuid, pgRelationshipToStudent, _id, LeloRegistrationProfile } });
    }
  };

  // Helper function to get CSS class for form validation
  const getInputClassName = (value) => {
    if (FormSubmit && !value) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="sub-form">
      <h2>
        Mailing Address
        <span>(5/7)</span> <hr />
      </h2>

      <div className="item">
        <div className="asterisk-group">
          <h3>Mailing Street</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <input
          type="text"
          name="mailingStreet"
          maxLength="50"
          onChange={handleChange}
          value={mailingStreet}
          className={getInputClassName(mailingStreet)}
        />
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>Mailing City</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <input
          type="text"
          name="mailingCity"
          maxLength="50"
          onChange={handleChange}
          value={mailingCity}
          className={getInputClassName(mailingCity)}
        />
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>Mailing State</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <select
          name="mailingState"
          value={mailingState}
          onChange={handleChange}
          className={getInputClassName(mailingState)}>
          <option value="">Please Select</option>
          {states.map((item) => (
            <option key={Object.keys(item)} value={Object.keys(item)}>
              {Object.keys(item)}
            </option>
          ))}
        </select>
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>Mailing Zip</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <input
          type="text"
          name="mailingZip"
          maxLength="5"
          required
          value={mailingZip}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, ""); 
            handleChange({ target: { name: "mailingZip", value } });
          }}
          className={getInputClassName(mailingZip)}
        />
        {mailingZip !== "" && !validatezipCode(mailingZip) && (
          <p className="validEmail">
            {` Please provide a valid Zip/Postal Code`}
          </p>
        )}
      </div>

      <div className="progress-btns">
        <div className="circle-btn" onClick={() => navigate(-1)}>
          <FaIcons.FaChevronLeft
            className="progress-level-btn"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="circle-btn" onClick={handleSubmit}>
          <FaIcons.FaChevronRight
            className="progress-level-btn"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default R5MailingAddress;